import { TextFieldVariants } from "@mui/material";
import SelectIdNameMultiple from "components/SelectIdNameMultiple";
import useLicenseFilterOptions from "hooks/useLicenseFilterOptions";
import { useIntl } from "react-intl";

type SelectLocationMultipleProps = {
  value: string[];
  onChange: (v: string[]) => void;
  variant?: TextFieldVariants;
  disabled?: boolean;
};

const SelectLocationMultiple = ({
  value,
  onChange,
  variant,
  disabled,
}: SelectLocationMultipleProps) => {
  const { formatMessage: t } = useIntl();
  const { data, isFetching } = useLicenseFilterOptions();

  return (
    <SelectIdNameMultiple
      label={t({ id: "locationLabel" })}
      options={data?.data?.locations ?? []}
      value={value}
      onChange={onChange}
      loading={isFetching}
      variant={variant}
      disabled={disabled}
    />
  );
};

export default SelectLocationMultiple;
